// extracted by mini-css-extract-plugin
export default {"title":"Title_title__VCqX9","regular":"Title_regular__zZmqF","modalRegular":"Title_modalRegular__jJwWa","onboarding":"Title_onboarding__qkfik","modal":"Title_modal__mqTUt"};